import axios from 'axios';

const api = 'https://iot.univertech.cn/house/park/';

const houseApi = 'https://iot.univertech.cn/house/detail/';

const urlParams = new URLSearchParams(window.location.search);
const rid = urlParams.get('rid');

const params = `rid=${rid}`;

export const request = async (type) => {
  const res = await axios.get(`${api}/${type}?${params}`);
  const { data, status } = res;
  if (status === 200) {
    return data;
  }
};

export const houseRequest = async (hid) => {
  const res = await axios.get(`${houseApi}/${hid}?${params}`);
  const { data, status } = res;
  if (status === 200) {
    return data;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { request, houseRequest };